import { ISearchListColumn } from 'component/Search/types';
import { chain } from 'lodash';
import { applyColumnRenderFunction } from './applyColumnRenderFunction';
import { mapListColumns } from './mapListColumns';

/** Handles some of the built in behavior of mapping items
 * to their spreadsheet equivalents.
 */
export const makeSpreadsheetItemList = <T>(
  items: T[],
  columns: ISearchListColumn[]
): any[] =>
  chain(items)
    //split arrays into rows
    .map(item => applyColumnRenderFunction(item, columns))
    .thru(items => mapListColumns(items))
    .value();
